type Case = "sentenceCase" | "titleCase" | "lowerCase";

const abbreviationMap: { [key: string]: string } = {
  vpn: "VPN",
};

function replaceAbbreviations(result: string): string {
  const words = result.split(" ");

  const processedWords = words.map((word) => {
    const lowerCaseWord = word.toLowerCase();
    if (abbreviationMap[lowerCaseWord]) {
      return abbreviationMap[lowerCaseWord];
    }
    return word;
  });

  return processedWords.join(" ");
}

// Note: we may need to add to this as we see fit
const nonTitleableWords = [
  "and",
  "the",
  "of",
  "a",
  "an",
  "in",
  "to",
  "is",
  "it",
  "for",
  "on",
  "with",
  "by",
  "that",
  "this",
  "as",
  "at",
];

const isTitleableWord = (word: string): boolean => {
  return !nonTitleableWords.includes(word);
};

export function getReadableText(
  str: string,
  { caseType = "sentenceCase" }: { caseType?: Case } = {},
): string {
  // Replace underscores with spaces and convert to lowercase
  let result = str.replace(/_/g, " ").toLowerCase();

  if (caseType === "titleCase") {
    result = result
      .split(" ")
      .map((word) =>
        isTitleableWord(word)
          ? word.charAt(0).toUpperCase() + word.slice(1)
          : word,
      )
      .join(" ");
  } else if (caseType === "sentenceCase") {
    result = result.charAt(0).toUpperCase() + result.slice(1);
  }

  return replaceAbbreviations(result);
}

/**
 * Returns two letter initials for the given text.
 * If there are two words, the initials will be the first letter of each word.
 * Otherwise, the initials will be the first two letters of the first word.
 */
export function getInitials(name: string) {
  const [firstName, lastName] = name.trim().split(/\s+/);
  if (lastName) {
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  } else {
    return firstName.slice(0, 2).toUpperCase();
  }
}

export function printOneleetConsoleBlurb() {
  console.log(
    `%c
   $$$$$$\\                        $$\\   $$$$$$\\   $$$$$$\\  $$$$$$$$\\
  $$$ __$$\\                     $$$$ | $$ ___$$\\ $$ ___$$\\ \\____$$  |
  $$$$\\ $$ |$$$$$$$\\   $$$$$$\\  \\_$$ | \\_/   $$ |\\_/   $$ |    $$  /
  $$\\$$\\$$ |$$  __$$\\ $$  __$$\\   $$ |   $$$$$ /   $$$$$ /    $$  /
  $$ \\$$$$ |$$ |  $$ |$$$$$$$$ |  $$ |   \\___$$\\   \\___$$\\   $$  /
  $$ |\\$$$ |$$ |  $$ |$$   ____|  $$ | $$\\   $$ |$$\\   $$ | $$  /
  \\$$$$$$  /$$ |  $$ |\\$$$$$$$\\ $$$$$$\\\\$$$$$$  |\\$$$$$$  |$$  /
   \\______/ \\__|  \\__| \\_______|\\______|\\______/  \\______/ \\__/


  Making effective cybersecurity painless

  We're hiring: https://www.ycombinator.com/companies/oneleet/jobs
  `,
    "font-family: monospace;",
  );
}
